var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreTextbookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3048_6417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.19903 27.6489H29.6341C29.6967 27.6489 29.7573 27.64 29.8155 27.6261C29.8202 27.6261 29.824 27.6269 29.8287 27.6269C30.2649 27.6269 30.6193 27.2729 30.6193 26.8364V4.49058C30.6194 4.05415 30.2649 3.69995 29.8287 3.69995H29.6357H10.4635H9.20014C7.09572 3.69995 5.38397 5.41209 5.38397 7.51593C5.38397 7.54414 5.38952 7.57092 5.39226 7.59816C5.38952 9.54158 5.36542 27.3992 5.38952 29.7467C5.38802 29.7927 5.3824 29.8375 5.3824 29.8838C5.3824 31.9068 6.9664 33.5629 8.9588 33.6881C8.99878 33.6942 9.03796 33.7 9.07944 33.7H29.8286C30.2648 33.7 30.6192 33.346 30.6192 32.9094V29.9334C30.6192 29.4971 30.2648 29.1427 29.8286 29.1427C29.3924 29.1427 29.038 29.4971 29.038 29.9334V32.1188H9.19903C7.99758 32.1188 7.01682 31.1649 6.96862 29.9754C6.96979 29.9542 6.97365 29.9341 6.97325 29.9125C6.97247 29.8778 6.9713 29.8238 6.97051 29.7519C7.03961 28.5812 8.01129 27.6489 9.19903 27.6489ZM9.73813 7.51593C9.73813 7.0795 10.0923 6.7253 10.5288 6.7253C10.9652 6.7253 11.3194 7.0795 11.3194 7.51593V23.5757C11.3194 24.0119 10.9652 24.3663 10.5288 24.3663C10.0923 24.3663 9.73813 24.0118 9.73813 23.5757V7.51593Z",
    fill: "#91E248"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3048_6417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(3 3.69995)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreTextbookIcon);
export default __webpack_public_path__ + "static/media/gre-textbook-icon.eb331512ca8497d4e229fcaf0f3f0f08.svg";
export { ForwardRef as ReactComponent };